import React from 'react'

import { Button } from '@fourthwall/components'

import { getEmailLink } from '../../utils/getEmailLink'
import * as S from './BookACallButtons.styled'

type BookACallButtonsProps = {
  calendarUrl?: string
  email?: string
}

export const BookACallButtons = ({ calendarUrl, email }: BookACallButtonsProps) => {
  return (
    <S.ButtonContainer>
      {calendarUrl && (
        <Button
          to={calendarUrl}
          analytics="bookACall"
          target="_blank"
          label="Book a call"
          appearance="primary"
          size="small"
        />
      )}

      {email && (
        <Button
          analytics="emailUs"
          label="Email us"
          appearance="secondary"
          size="small"
          target="_blank"
          href={getEmailLink({ email, subject: 'Could you help me with my Fourthwall shop?' })}
        />
      )}
    </S.ButtonContainer>
  )
}
